'use strict';

/*
  vehicle-compare-multiple.xsl contains a 'relatedPages' prop that is NOT in use,
  due to its previous implementation never being correct.
  This is something that is in place in case this 'has related compare page'
  feature is ever requested to work properly.
*/
define('features/compare/compare-table',[
  'jquery',
  'Handlebars',
  'txt!./compare.table.hbs',
  'txt!./compare.table.header.hbs',
  'txt!./compare.table.body.hbs',
  'txt!tmpl/generic.loader.hbs',
  'txt!tmpl/generic.fail.hbs',
  'components/slicker',
  'lib/services/compare-service-jato',
  './compare.config.jato',
  'lib/services/compare-service-chrome',
  './compare.config.chrome',
  'lib/util/tda.config',
  'zipTools',
  'lib/util/zip',
  'lib/ucFirst',
  'lib/ucFirstEach',
  'lib/page-cache',
  'disclaimers',
  'modernizr',
  'lib/util/langFromUrl',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',
  'lib/scroller',

  // Side Effect Includes
  'lib/transforms/series.mapByCode', // adds our series.map PageCache Item
  'lib/helpers/disclaimer',
  'lib/helpers/concat'
], function (
  $,
  Handlebars,
  txtTemplate,
  txtTemplateHeader,
  txtTemplateBody,
  txtLoader,
  txtFail,
  Slicker,
  compareServiceJato,
  compareConfigJato,
  compareServiceChrome,
  compareConfigChrome,
  tdaConfig,
  zipTools,
  zip,
  ucFirst,
  ucFirstEach,
  PageCache,
  disclaimers,
  modernizr,
  langFromUrl,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext,
  scroller
) {
  var __tmplTable = Handlebars.compile(txtTemplate);
  var __tmplTableHeader = Handlebars.compile(txtTemplateHeader);
  var __tmplTableBody = Handlebars.compile(txtTemplateBody);
  var __tmplLoader = Handlebars.compile(txtLoader);
  var __tmplFail = Handlebars.compile(txtFail);
  var __isMobile = !!modernizr.mobile;
  var __compareService;
  var __compareConfig;
  var __prevAriaLabel = langFromUrl() === 'es' ? 'Anterior' : 'Previous';
  var __nextAriaLabel = langFromUrl() === 'es' ? 'Siguiente' : 'Next';

  // TODO: move these out?
  function __determineService(trims) {
    /* __compareService = compareServiceChrome;
    __compareConfig = compareConfigChrome; */

    // for testing
    // trims = [73598242018, 71036452018]; // hybrids
    // trims = [78556012018, 1569282018]; // non-hybrids camry vs accord

    if (trims[0].toString().length <= 5) {
      __compareService = compareServiceChrome;
      __compareConfig = compareConfigChrome;
    } else {
      __compareService = compareServiceJato;
      __compareConfig = compareConfigJato;
    }
  }

  function __properToyModelNames(model) {
    var seriesMap = PageCache.get('series.map');
    var tmpModel = model.toLowerCase().replace(/\s/g, '');
    if (seriesMap.hasOwnProperty(tmpModel)) {
      return seriesMap[tmpModel].series_display_name;
    }
    return model;
  }

  function __removeTrimDetail(trimName) {
    if (trimName.indexOf('(') !== -1) {
      return trimName.substr(0, trimName.indexOf('(')).trim();
    }
    return trimName;
  }

  function __imageUrl(url) {
    if (url.startsWith('/tcom')) {
      return '/assets/img' + url;
    }
    return url.replace(/^http:\/\//i, 'https://');
  }

  function __addComp(item) {
    return {
      img: __imageUrl(item.imageURL),
      brand: ucFirst(item.makeName.toLowerCase()),
      model: ucFirstEach(item.modelName.toLowerCase()),
      trim: __removeTrimDetail(item.trimName),
      year: item.modelYear
    };
  }

  function __xformCompareData(data, competitorIdx, comprehensive) {
    // competitorIdx defaults (and starts at 1), on slideshow change
    // Toyota data is always at index 0. the first competitor at index 1, the next at index 2, etc.
    // on slideshow change, pass in current slide index to get data for the appropriate vehicle
    competitorIdx = competitorIdx || 1;
    var ctxObj = {
      header: {
        primaryVehicle: {},
        competitorVehicle: []
      },
      // comparisonData.heading
      body: {},
      summary: {}
    };
    // setup the header primary (TOY) vehicle
    ctxObj.header.primaryVehicle.img = __imageUrl(data.primaryVehicle.imageURL);
    ctxObj.header.primaryVehicle.brand = ucFirst(data.primaryVehicle.makeName.toLowerCase());
    ctxObj.header.primaryVehicle.model = __properToyModelNames(data.primaryVehicle.modelName);
    ctxObj.header.primaryVehicle.trim = __removeTrimDetail(data.primaryVehicle.trimName);
    ctxObj.header.primaryVehicle.year = data.primaryVehicle.modelYear;

    // Setup competitor Vehicle slides
    data.competitorVehicle.forEach(function (item) {
      ctxObj.header.competitorVehicle.push(__addComp(item));
    });

    // setup the body context. Specific to current index
    var headings = data.comparisonData.heading;
    var usefulHeadings = headings;

    var bigCats = [];
    for (var j = 0; j < usefulHeadings.length; j++) {
      var rowAndSubHeadingData = usefulHeadings[j].rowAndSubHeading;
      for (var k = 0; k < rowAndSubHeadingData.length; k++) {
        var tmpObj = {};
        var catPriority;
        tmpObj.rowLabel = rowAndSubHeadingData[k].rowLabel;
        tmpObj.vehicleData = rowAndSubHeadingData[k].vehicleData;
        // Chrome: Grab from the competitor data, which always lives at competitorIdx, on single and multi compares.
        // Jato, double check this hasAdvantage data! it SHOULD live in the same spot, but alas, these are all false.
        var hasAdvantage = rowAndSubHeadingData[k].vehicleData[0].advantageFlag; // Jato: always look at OUR vehicle
        // Chrome: var hasAdvantage = rowAndSubHeadingData[k].vehicleData[k].advantageFlag; // Jato: always look at OUR vehicle
        // chrome would add this true flag to each competitor. We need this same setup for multi vehicle comparisons
        if (hasAdvantage === 'True') {
          tmpObj.hasAdvantage = true;
        } else {
          tmpObj.hasAdvantage = false;
        }
        // Add a priority level for current row label, based on our catPriorities arr
        if (__compareConfig.isSpanish) {
          catPriority = __compareConfig.catPrioritesObjEs[tmpObj.rowLabel];
        } else {
          catPriority = __compareConfig.catPrioritesObjEn[tmpObj.rowLabel];
        }
        // if this category is a property on our priority obj use that. Otherwise, use 1000
        tmpObj.priority = catPriority || 1000;
        bigCats.push(tmpObj);
      }
    }

    // tmpObj.body = data.competitorVehicle[competitorIdx];
    var usedRows = [];
    var noLosersArr = [];
    $(bigCats).each(function (index, itemData) {
      var rowLabel = itemData.rowLabel;
      var hasAdvantage = itemData.hasAdvantage;
      var priority = itemData.priority;
      var toyotaVal = itemData.vehicleData[0].colData; // Toyota is always the first item in this arr
      var compVal = itemData.vehicleData[competitorIdx].colData; // competitor value

      /*-----------------------------------------------------------------
      Don't use a category if its been used before
        - as we use each rowLabel, stash it in usedRows[] when we're done
      ------------------------------------------------------------------*/
      if (usedRows.indexOf(rowLabel) === -1) {
        if (comprehensive) { // all cats
          noLosersArr.push({
            rowLabel: rowLabel,
            toyotaVal: toyotaVal,
            compVal: compVal,
            hasAdvantage: hasAdvantage,
            priority: priority
          });
        } else if (hasAdvantage) {
          var tmpAdvObj = {
            rowLabel: rowLabel,
            toyotaVal: toyotaVal,
            compVal: compVal,
            hasAdvantage: hasAdvantage,
            priority: priority
          };
          noLosersArr.push(tmpAdvObj);
        }
      }
      usedRows.push(rowLabel);
    });

    // Descending order based on priority
    noLosersArr.sort(function (a, b) {
      return parseFloat(a.priority) - parseFloat(b.priority);
    });
    var rowsToShow = __compareConfig.rowsToShow;
    if (comprehensive) {
      rowsToShow = noLosersArr.length;
    }
    // tack on the row Class
    var rowCount = 1;
    noLosersArr.forEach(function (item) {
      if (rowCount % 2 === 0) {
        item.rowClass = 'cv-highlight';
      }
      rowCount++;
    });
    ctxObj.body.results = noLosersArr.slice(0, rowsToShow);

    // Build and tack on a summary row
    var summaryRow = __compareConfig.buildSummaryRow(headings, competitorIdx);
    summaryRow.series_code = data.primaryVehicle.modelName.replace(' ', '').toLowerCase();
    ctxObj.summary = summaryRow;

    return ctxObj;
  }

  var CompareComponent = function (el, config) {
    this.$el = $(el); // node to output actual table to
    this._config = config;
    this.trims = config.trims.toString();
    this._trims = config.trims;
    this.comprehensive = config.comprehensive || false;
    this.$simpleIntroEl = $(config.simpleIntroEl) || null; // simple skins have this Intro node
    this.$tableParentEl = $(config.tableParentEl) || null; // simple skins need a notion of a table parent
    this.initialize.apply(this, arguments);
    this.compareKeys = this.buildCompareKeys();
  };

  $.extend(CompareComponent.prototype, {
    initialize: function (el, config) {
      __determineService(this._trims);
      this.service = this._trims[0].toString().length <= 5 ? 'chrome' : 'jato';
    },

    load: function () {
      var self = this;
      self.$el.html(__tmplLoader()); // TODO: set height on 'empty' table
      self.requestReport();
      var cacheIds = ['series.map'].concat(self.compareKeys);

      PageCache.awaitAll(cacheIds)
        .then(function pageCacheDone() {
          self._report = PageCache.get(self.compareKeys[0]); // start with the first report
          // if JATO and bad data, our self._report is an array
          if (self.service === 'jato') {
            self._report = [];
            self.compareKeys.forEach(function (compareKey) {
              self._report.push(PageCache.get(compareKey));
            });
            self.year = self._report[0].primaryVehicle.modelYear;
            self.renderPage(self._report[0]);
          } else {
            self.year = self._report.primaryVehicle.modelYear;
            self.renderPage(self._report);
          }
        })
        .catch(function (err) {
          console.error('Compare Table not loaded:', err, 'cachedIds:', cacheIds); // eslint-disable-line no-console
          self.reportFail();
        });
    },

    buildCompareKeys: function () {
      var self = this;
      var compareKeys = ['compare.compareTable'];
      if (self.service === 'jato') {
        compareKeys = self._trims.map(function (key) {
          return compareKeys + '.' + self._trims[0] + '.vs.' + key;
        });
        compareKeys.shift(); // drop the TOY vehicle
      }

      return compareKeys;
    },

    requestReport: function () {
      var self = this;
      var cacheId = self.compareKeys;
      var serviceLangCode = __compareConfig.isSpanish ? 2 : 1;
      var competitorCode = 1;

      function vehicleString() {
        if (self.service === 'jato') {
          return self._trims[0] + ',' + self._trims[competitorCode];
        }
        return self.trims;
      }

      cacheId.forEach(function (cacheKey) {
        if (!PageCache.hasOrPending(cacheKey)) {
          PageCache.maybeSet(cacheKey, __compareService.report().fetch({
            vehicles: vehicleString(),
            langCode: serviceLangCode
          }));
        }
        competitorCode += 1;
      });
    },

    // to match the currently live site, we do not display any messaging at all,
    // when a compare table fails (2016 vehicles)
    reportFail: function () {
      $(document).trigger('COMPARE_FAIL');
      var ctx = {
        headline: 'Unable to retrieve comparison',
        message: ''
      };
      this.$el.html(__tmplFail(ctx));
    },

    buildContext: function (report, compIdx) {
      var ctx = __xformCompareData(report, compIdx, this.comprehensive);
      ctx.header.isMobile = __isMobile;
      ctx.footer = __compareConfig.footerCtx();
      this.ctx = ctx;
      return ctx;
    },

    // renderPage only happens once
    renderPage: function (report) {
      var self = this;
      var ctx = this.buildContext(report, 1);
      if (self.service === 'jato') {
        var tmpReports = self._report.slice();
        tmpReports.shift();
        tmpReports.forEach(function (currReport) {
          ctx.header.competitorVehicle.push(__addComp(currReport.competitorVehicle[0]));
        });
      }
      // build two reports, and meld competitorVehicle together.
      this.$el.html(__tmplTable(ctx));
      this.$el.find('.compare-table-header').html(__tmplTableHeader(ctx.header));
      this.renderBody(ctx);
      this.renderSimpleFooter(ctx);
      this.slideShow();
      this.checkCtas();
      this.tableDisclaimers();
      this.analytics(report);
    },

    // invoked via slideshow change and first render
    renderBody: function (ctx) {
      this.$el.find('.compare-table-body').html(__tmplTableBody(ctx));
      console.log('CTX of compare table body: ', ctx); // eslint-disable-line no-console
    },

    determineScope: function () {
      if (this.$tableParentEl && this.$tableParentEl.length) {
        return this.$tableParentEl;
      }
      return this.$el;
    },

    // default context, invoked once
    analytics: function (report) {
      var toy = report.primaryVehicle;
      var comp = report.competitorVehicle[0];
      var $tableScope = this.determineScope();
      var compObj = {
        brand: comp.makeName,
        grade: comp.trimName,
        year: comp.modelYear,
        model: comp.modelName,
        msrp: ''
      };
      var seriesObj = {
        series_code: toy.modelName,
        grade: toy.trimName,
        year: toy.modelYear
      };
      anAddContext(
        $tableScope,
        blocks.sectionBlock('compare'),
        blocks.seriesBlock(seriesObj),
        blocks.compareBlock(compObj)
      );
      anClicks($tableScope);
      scroller.add($tableScope, {
        after: function viewAfter() {
          anPageLoad($(this), blocks.keyMetrics('km-seo-compare'));
        }
      });

      this.analyticsSimpleSkin(compObj, seriesObj);
    },

    analyticsSimpleSkin: function (compObj, seriesObj) {
      var $introScope = this.$simpleIntroEl;
      if ($introScope && $introScope.length) {
        anAddContext(
          $introScope,
          blocks.sectionBlock('compare intro'),
          blocks.seriesBlock(seriesObj),
          blocks.compareBlock(compObj)
        );
        anClicks($introScope);
        scroller.add($introScope, {
          after: function viewAfter() {
            anPageLoad($(this));
          }
        });
      }
    },

    // new context for "upcoming" slide change
    analyticsChangeComp: function (report) {
      var comp = report.competitorVehicle[0];
      anAddContext(
        this.$el,
        blocks.compareBlock({
          brand: comp.makeName,
          grade: comp.trimName,
          year: comp.modelYear,
          model: comp.modelName,
          msrp: ''
        })
      );
    },

    // simple /compare/ pages need to have their comparison service credit line output
    renderSimpleFooter: function (ctx) {
      if (this.$simpleIntroEl && this.$simpleIntroEl.length) {
        this.$simpleIntroEl.find('#js-compare-intro-credits').html(ctx.footer.credit);
      }
    },

    slideShow: function () {
      var self = this;
      self.competitorSlides = new Slicker({
        $slider: $('.compare-slideshow', self.$el),
        slickOptions: {
          mobileFirst: true,
          fade: true,
          slide: '.compare-slide',
          slidesToShow: 1,
          infinite: true,
          autoplay: false,
          arrows: !__isMobile,
          dots: !__isMobile,
          paddingBottom: 18,
          initFunction: function () {
            self.competitorSelect();
            var $bxPrev = $('.compare-slideshow').find('.bx-prev');
            var $bxNext = $('.compare-slideshow').find('.bx-next');
            // PREVIOUS ARROW KEY DOWN BAT-4016
            $bxPrev.keydown(function (event) {
              if (event.keyCode !== 13 && event.keyCode !== 9) {
                event.preventDefault();
                event.stopPropagation();
                return;
              }
              if (event.keyCode === 13) {
                $bxPrev.trigger('click');
              }
            });
            // NEXT ARROW KEY DOWN BAT-4016
            $bxNext.keydown(function (event) {
              if (event.keyCode !== 13 && event.keyCode !== 9) {
                event.preventDefault();
                event.stopPropagation();
                return;
              }
              if (event.keyCode === 13) {
                $bxNext.trigger('click');
              }
            });
          },
          beforeFunction: function (event, slick, currentSlide, nextSlide) {
            if (self.service === 'jato') {
              self.slideChangeJato(nextSlide);
            } else {
              self.slideChange(nextSlide + 1);
            }
          },
          tablet: {
            appendArrows: $('.compare-slideshow-controls', self.$el),
            prevArrow: '<div class="carousel-prev datalayer-link"><a role="button" class="bx-prev unstyled" tabIndex="0" data-linktext="competitor_selector_previous" aria-label="' + __prevAriaLabel + '"><i class="icon icon-arrow-thin-left"></i></a></div>',
            nextArrow: '<div class="carousel-next datalayer-link"><a role="button" class="bx-next unstyled" tabIndex="0" data-linktext="competitor_selector_next" aria-label="' + __nextAriaLabel + '"><i class="icon icon-arrow-thin-right"></i></a></div>',
          }
        }
      });
    },

    slideChange: function (compIdx) {
      var self = this;
      var newCtx = self.buildContext(self._report, compIdx);
      self.renderBody(newCtx);
      self.tableDisclaimers();
      self.analyticsChangeComp(self._report);
    },

    slideChangeJato: function (compIdx) {
      var self = this;
      var newCtx = self.buildContext(self._report[compIdx], 1);
      self.renderBody(newCtx);
      self.tableDisclaimers();
      self.analyticsChangeComp(self._report[compIdx]);
    },

    competitorSelect: function () {
      var self = this;
      if (__isMobile) {
        $('.js-cv-select').on('change', function () {
          self.competitorSlides.$slider.slick('slickGoTo', $(this).val());
        });
      }
    },

    checkCtas: function () {
      if (tdaConfig.tda.code === 'WWW') {
        this.ctaListeners();
      }
      if (tdaConfig.tda.code !== 'SET10') {
        this.ctaInventory();
      }
    },

    // TODO: update to use new CTA handling
    // currently applies to ALL CTAs in the DOM.
    // this.$el does not contain them, otherwise we'd use that as a parent selector
    // or, should we be doing this on a component level?
    // note: CTAs only present on stand alone compare pages
    ctaListeners: function () {
      $('a[data-destination="trade-in-value"], a[data-destination="find-a-dealer"]').on('click', function (e) {
        e.preventDefault();
        var page = $(this).attr('href').replace('/en', '').replace('/es', '');
        zipTools.promptUserForZip(zip.getCookiedDefaultFallback(), page);
      });
    },

    ctaInventory: function () {
      var self = this;
      // var $inventoryCompareLinks = $('a[data-destination="inventory"]');
      // $inventoryCompareLinks.each(function () {
      //   var $this = $(this);
      //   $this.attr('href', $this.attr('href').replace('/en', '').replace('/es', '') + '&year=' + self.year);
      // });
      // fmp.attachInventoryClicks($inventoryCompareLinks);
    },

    tableDisclaimers: function () {
      disclaimers.msrpMpgDigits('#' + this.$el.prop('id')); // #js-compare-table
    }
  });

  return CompareComponent;
});

